import AvailabilityStatusCIrcule from "../../../../../utilities/AvailabilityStatusCIrcule";
import {STATUS_COLORS} from "../../../../../utilities/colorConstants";

export const REQUEST_TABLE_COLUMNS = Object.freeze([
  {
    header: "№",
    accessorKey: "number",
    size: 50,
  },
  {
    header: "Status",
    accessorKey: "statusCircle",
    size: 50,
    cell: circleColor => (
      <div style={{display: "flex", justifyContent: "center", alignItems: "center", height: "100%"}}>
        <AvailabilityStatusCIrcule color={circleColor.getValue()} />
      </div>
    ),
  },

  {
    header: "Request status",
    accessorKey: "requestStatus",
    size: 200,
    cell: info => (
      <span style={{color: info.row.original?.isPfFullyApproved ? STATUS_COLORS.GREEN : undefined}}>
        {info.getValue()}
      </span>
    ),
  },

  {
    header: "Request №",
    accessorKey: "requestNumber",
    size: 250,
  },
  {
    header: "COf custom naming",
    accessorKey: "cofSecondNumber",
  },
  {
    header: "Factory",
    accessorKey: "factory",
    size: 200,
  },
  {
    header: "Request amount",
    accessorKey: "requestSum",
    size: 100,
    cell: (
      info, //*symbol for tooltip
    ) => <div title={`${info.row.original?.requestSum ?? ""} €`}>{info.getValue()}</div>,
    textAlign: "right",
  },
  {
    header: "Prof sum",
    accessorKey: "profSum",
    size: 100,
    textAlign: "right",
  },
  {
    header: "Payed",
    accessorKey: "payedSum",
    size: 100,
    textAlign: "right",
  },
  {
    header: "Request date",
    accessorKey: "createdAt",
    size: 100,
  },

  {
    header: "Bring to",
    accessorKey: "bringTo",
    size: 100,
  },
  {
    header: "Product country",
    accessorKey: "country",
    size: 100,
  },
  {
    header: "Prof №",
    accessorKey: "prof",
    size: 100,
  },
  {
    header: "Invoice №",
    accessorKey: "invoice",
    size: 100,
  },
  {
    header: "Packing List №",
    accessorKey: "packL",
    size: 100,
  },
  {
    header: "Stock pool №",
    accessorKey: "stockPool",
    size: 100,
  },
  {
    header: "Notes",
    accessorKey: "note",
    alignStart: true,
    size: 270,
    maxSize: 270,
  },
  {
    header: "CO Manager",
    accessorKey: "managerCo",
    size: 100,
    maxSize: 100,
    isSortable: true,
    // size: 100,
  },
  {
    header: "FEA Manager",
    accessorKey: "managerFea",
    size: 100,
    maxSize: 100,
    isSortable: true,
    // size: 100,
  },
]);

export const MANAGER_CO_INCOMING_REQ_TABLE = Object.freeze([
  {
    header: "№",
    accessorKey: "number",
    size: 15,
  },

  {
    header: "CO №",
    accessorKey: "coNumber",
    // size: 100,
  },
  {
    header: "Order",
    accessorKey: "requestNumber",
    // size: 100,
  },
  {
    header: "CO Manager",
    accessorKey: "managerCo",
    // size: 100,
  },
  {
    header: "Factory",
    accessorKey: "factory",
    // size: 100,
  },
  {
    header: "Request amount",
    accessorKey: "requestSum",
    // size: 100,
  },
  {
    header: "Request date",
    accessorKey: "createdAt",
    // size: 100,
  },
  {
    header: "Bring to",
    accessorKey: "bringTo",
    // size: 15,
  },
  {
    header: "Product country",
    accessorKey: "country",
    // size: 100,
  },

  {
    header: "Product group",
    accessorKey: "productGroup",
    // size: 100,
  },
  {
    header: "Notes",
    accessorKey: "note",
    alignStart: true,
    // size: 100,
  },
  // {
  //   header: "Status*",
  //   accessorKey: "status",
  //   // size: 100,
  // },
]);

export const MANAGER_CO_APPOINTED_REQ_TABLE = Object.freeze([
  {
    header: "№",
    accessorKey: "number",
    size: 15,
  },

  {
    header: "CO №",
    accessorKey: "coNumber",
    // size: 100,
  },
  {
    header: "Order",
    accessorKey: "requestNumber",
    // size: 100,
  },
  {
    header: "CO Manager",
    accessorKey: "managerCo",
    // size: 100,
  },
  {
    header: "Manager FEA",
    accessorKey: "managerFea",
    // size: 100,
  },
  {
    header: "Factory",
    accessorKey: "factory",
    // size: 100,
  },
  {
    header: "Request amount",
    accessorKey: "requestSum",
    // size: 100,
  },
  {
    header: "Request date",
    accessorKey: "createdAt",
    // size: 100,
  },
  {
    header: "Bring to",
    accessorKey: "bringTo",
    // size: 15,
  },
  {
    header: "Product country",
    accessorKey: "country",
    // size: 100,
  },

  {
    header: "Product group",
    accessorKey: "productGroup",
    // size: 100,
  },
  {
    header: "Notes",
    accessorKey: "note",
    alignStart: true,
    // size: 100,
  },
  // {
  //   header: "Status*",
  //   accessorKey: "status",
  //   // size: 100,
  // },
]);

export const LOGIST_REQ_TABLE = Object.freeze([
  {
    header: "№",
    accessorKey: "number",
    size: 15,
  },
  {
    header: "Request №",
    accessorKey: "requestNumber",
  },
  {
    header: "CO Manager",
    accessorKey: "managerCo",
  },
  {
    header: "Factory",
    accessorKey: "factory",
  },
  {
    header: "Request amount",
    accessorKey: "requestSum",
  },
  {
    header: "Date of Readiness",
    accessorKey: "readinessDate",
  },
  {
    header: "Bring to",
    accessorKey: "bringTo",
  },
  {
    header: "Country prof",
    accessorKey: "profCountry",
  },
  {
    header: "Product country",
    accessorKey: "productCountry",
  },

  {
    header: "Product group",
    accessorKey: "productGroup",
    size: 150,
    maxSize: 150,
  },
]);

export const LOGIST_REQ_TABLE_WITH_SP = Object.freeze([
  {
    header: "№",
    accessorKey: "number",
    size: 15,
  },
  {
    header: "Stock pool №",
    accessorKey: "spNumber",
  },
  {
    header: "Request №",
    accessorKey: "requestNumber",
  },
  {
    header: "CO Manager",
    accessorKey: "managerCo",
  },
  {
    header: "Factory",
    accessorKey: "factory",
  },
  {
    header: "Request amount",
    accessorKey: "requestSum",
  },
  {
    header: "Date of Readiness",
    accessorKey: "readinessDate",
  },
  {
    header: "Bring to",
    accessorKey: "bringTo",
  },
  {
    header: "Country prof",
    accessorKey: "profCountry",
  },
  {
    header: "Product country",
    accessorKey: "productCountry",
  },

  {
    header: "Product group",
    accessorKey: "productGroup",
    size: 150,
    maxSize: 150,
  },
]);

export const DISTRIBUTED_REQ_TABLE = Object.freeze([
  {
    header: "№",
    accessorKey: "number",
    size: 15,
  },
  {
    header: "Request №",
    accessorKey: "requestNumber",
  },
  {
    header: "CO Manager",
    accessorKey: "managerCo",
  },
  {
    header: "mng log",
    accessorKey: "logist",
  },
  {
    header: "Factory",
    accessorKey: "factory",
  },
  {
    header: "Request amount",
    accessorKey: "requestSum",
  },
  {
    header: "Date of Readiness",
    accessorKey: "readinessDate",
  },
  {
    header: "Bring to",
    accessorKey: "bringTo",
  },
  {
    header: "Country prof",
    accessorKey: "profCountry",
  },
  {
    header: "Product country",
    accessorKey: "productCountry",
  },

  {
    header: "Product group",
    accessorKey: "productGroup",
    size: 150,
    maxSize: 150,
  },
]);

export const SP_TABLE = Object.freeze([
  {
    header: "№",
    accessorKey: "number",
    size: 15,
  },

  {
    header: "Stock pool №",
    accessorKey: "stockPoolNumber",
  },
]);
export const SP_CHECK_TABLE = Object.freeze([
  {
    header: "№",
    accessorKey: "number",
    size: 15,
  },
  {
    header: "Stock pool №",
    accessorKey: "stockPoolNumber",
  },
  {
    header: "FDP",
    accessorKey: "fdp",
    // textAlign: "center",
    size: 75,
  },
  {
    header: "Transport Pool №",
    accessorKey: "transportPoolNumber",
  },
]);
export const LOGIST_DISTRIB_REQ_TABLE = Object.freeze([
  {
    header: "№",
    accessorKey: "number",
    size: 15,
  },
  {
    header: "TP №",
    accessorKey: "tpNumber",
  },
  {
    header: "Request №",
    accessorKey: "requestNumber",
  },
  {
    header: "CO Manager",
    accessorKey: "managerCo",
  },
  {
    header: "Factory",
    accessorKey: "factory",
  },
  {
    header: "Request amount",
    accessorKey: "requestSum",
  },
  {
    header: "Date of Readiness",
    accessorKey: "createdAt",
  },
  {
    header: "Bring to",
    accessorKey: "bringTo",
  },
  {
    header: "Product country",
    accessorKey: "country",
  },

  {
    header: "Product group",
    accessorKey: "productGroup",
  },
  {
    header: "Notes",
    accessorKey: "note",
    alignStart: true,
  },
]);
